module.exports = __webpack_public_path__ + "static/media/teamwork-and-brainstorming-1460453-1234504.3f7f7034.jpg";